import { MNSproCloudApi } from '..';
import { AbsenceReasonResponse } from '../api/v2';

export interface PcSettingsValues {
  AccessFiles: boolean;
  AddAbsences: PcSettingsAbsenceValues;
  TranslateNews: boolean;
  ViewAbsences: boolean;
  ViewCourseCalendar: boolean;
  ViewHomework: boolean;
  ViewNews: boolean;
  ViewSchoolWideCalendar: boolean;
  LetterToParents: PcSettingsParentalLettersValues;
  ViewTimeTable: {
    isEnabled: boolean;
    viewableDays: number;
  };
  AbsencesSettings: {
    disclaimerText: string;
  };
  ViewLessonContent: boolean;
  GuardianChat: PcSettingsGuardianChatValues;
  ImportGuardianContacts: boolean;
}

export enum PcSettingsAbsenceSubmissionDeadline {
  NoRestriction = 'NoRestriction',
  UntilLessonStart = 'UntilLessonStart',
  UntilEndOfDay = 'UntilEndOfDay',
  OneDayBefore = 'OneDayBefore',
  TwoDaysBefore = 'TwoDaysBefore',
  ThreeDaysBefore = 'ThreeDaysBefore',
}

export interface PcSettingsParentalLettersValues {
  signature: string;
  canBeTranslatedAutomatically: boolean;
}

export interface PcSettingsAbsenceValues {
  recipientMail: string;
  sendMail: boolean;
  reasons: string[];
  isEnabled: boolean;
  absenceSubmissionDeadline: PcSettingsAbsenceSubmissionDeadline;
  isNoteMandatory: boolean;
}

export interface PcSettingsGuardianChatValues {
  isEnabled: boolean;
  canBeTranslatedAutomatically: boolean;
}

export class ParentalCommunicationSettingsService {
  private constructor() {}

  private static getApi(authToken: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ParentalCommunicationApiFactory(config);
    return api;
  }

  static async getSettings(
    authToken: string,
    organizationId: string,
  ): Promise<PcSettingsValues | null> {
    const api = ParentalCommunicationSettingsService.getApi(authToken);
    const response = await api.getSettings(organizationId);
    return response.data.settings === undefined
      ? null
      : (response.data.settings as PcSettingsValues);
  }

  static async saveSettings(authToken: string, organizationId: string, values: PcSettingsValues) {
    const api = ParentalCommunicationSettingsService.getApi(authToken);
    const response = await api.createOrUpdateSettings(organizationId, values);
    return response.data.settings === undefined
      ? null
      : (response.data.settings as PcSettingsValues);
  }

  static async getClassbookAbsenceReasons(
    authToken: string,
    organizationId: string,
  ): Promise<AbsenceReasonResponse[]> {
    const api = ParentalCommunicationSettingsService.getApi(authToken);
    const response = await api.getAbsenceReasons(organizationId);
    return response.data;
  }
}
